import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ThemeProvider } from '@material-tailwind/react';
import { Provider } from 'react-redux';
import { persistor, store } from './store/index';
import Toaster from './components/common/Toaster';
import { PersistGate } from 'redux-persist/integration/react';
import { ChunkErrorBoundary } from './components/common/ChunkErrorBoundary';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: 1,
      refetchInterval: 600_000,
    },
  },
});

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

if (!googleClientId) {
  throw new Error('REACT_APP_GOOGLE_CLIENT_ID is not defined');
}

const router = createBrowserRouter([
  { path: "*", Component: App }
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ChunkErrorBoundary>
      <GoogleOAuthProvider clientId={googleClientId}>
        <QueryClientProvider client={queryClient}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <AuthProvider>
                <RouterProvider router={router} />
              </AuthProvider>
            </PersistGate>
          </Provider>
          <Toaster />
        </QueryClientProvider>
      </GoogleOAuthProvider>
    </ChunkErrorBoundary>
  </React.StrictMode>,
);
